import script from "./onboarding-form.vue?vue&type=script&setup=true&lang=js"
export * from "./onboarding-form.vue?vue&type=script&setup=true&lang=js"

import "./onboarding-form.vue?vue&type=style&index=0&id=2479f24d&lang=scss"

const __exports__ = script;

export default __exports__